<template>
  <div class="handle-wrap">
    <div class="handle-btn">
      <p @click="showRecord"><img src="//res.aidalan.com/hd/sg/img/record.png"></p>
      <p @click="showAddr"><img src="//res.aidalan.com/hd/sg/img/receive.png"></p>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    showRecord() {
      this.$emit('recordModel');
    },
    showAddr() {
      this.$emit('addrModel');
    },
  },
};
</script>

<style>
.handle-btn{
  padding: 2% 0;
  display: flex;
  justify-content: center;
}
.handle-btn p{
  width: 34%;
  cursor: pointer;
}
.handle-btn p:first-child{
  margin-right: 6%;
}
.handle-btn img{
  display: block;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Handle.vue